import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

type RegisterRequest = {
  requestId: string;
};

export type ApproveRegisterRequestParams = RequestConfig<RegisterRequest>;

export const approveRegisterRequest = async ({
  params,
  config
}: ApproveRegisterRequestParams) =>
  api.put(
    `/api/registrationrequests/${params.requestId}/approve`,
    params,
    config
  );
